import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

// only instantiate the class for testing.
export class StripeLoader {
  private stripePromises = new Map<string, Promise<Stripe | null>>();

  getStripe(key?: string | null): Promise<Stripe | null> | null {
    if (!key) return null;
    if (!this.stripePromises.has(key)) {
      try {
        this.stripePromises.set(key, loadStripe(key));
      } catch (e) {
        console.error(e);
      }
    }

    return this.stripePromises.get(key) ?? null;
  }
}

export const stripeLoader = new StripeLoader();
